import React from 'react';
import PropTypes from 'prop-types';
import { threeDotsIcon } from 'images';

const MoreButton = ({ onClick, innerRef }) => (
	<button
		ref={innerRef}
		type="button"
    className="focus:outline-none w-full py-1"
    style={{ height: 45 }}
		onClick={onClick}>
		<img
			src={threeDotsIcon}
			className="w-full pointer-events-none"
			alt="More options" />
	</button>
);

MoreButton.propTypes = {
	onClick: PropTypes.func,
	innerRef: PropTypes.func
};

export default MoreButton;
